/** @prettier */

/**
 * ソート関連関数一覧
 */

//interface import
import * as apiIF from '../Type/api';

/**
 * ユニコード昇順で並び替える
 * Array.prototype.sort()の引数専用
 * @param {string} key 比較するプロパティ
 * @returns Array.prototype.sort()用引数
 */
const sortByUnicode = (key?: string) => {
  if (key === undefined) {
    return (a: any, b: any) => {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      }
      return 0;
    };
  }

  return (a: any, b: any) => {
    if (key in a === false || key in b === false) {
      return 0;
    }

    if (a[key] < b[key]) {
      return -1;
    } else if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  };
};

/**
 * ゲートウェイの情報の並び替え
 * @param gwInfo ゲートウェイの情報
 * @returns ソートされたゲートウェイの情報
 */
const gwInfoSort = (gwInfo: apiIF.res.getCompositionsGateway) => {
  const result: apiIF.res.getCompositionsGateway = JSON.parse(
    JSON.stringify(gwInfo)
  );

  //ゲートウェイの名前で並び替え
  result['gateway-informations'].sort(sortByUnicode('gateway-name'));

  for (const info of result['gateway-informations']) {
    if (info.compositions === undefined) continue;
    //SL
    //室外機の名前で並び替え
    if (info.compositions['sl-system-1']['sl-unit'].length > 0) {
      info.compositions['sl-system-1']['sl-unit'].sort(
        sortByUnicode('outdoor-unit-name')
      );
      //室内機の名前で並び替え
      for (const ouInfo of info.compositions['sl-system-1']['sl-unit']) {
        if (ouInfo['indoor-unit'].length === 0) continue;
        ouInfo['indoor-unit'].sort(sortByUnicode('indoor-unit-name'));
      }
    }
    if (info.compositions['sl-system-2']['sl-unit'].length > 0) {
      info.compositions['sl-system-2']['sl-unit'].sort(
        sortByUnicode('outdoor-unit-name')
      );
      for (const ouInfo of info.compositions['sl-system-2']['sl-unit']) {
        if (ouInfo['indoor-unit'].length === 0) continue;
        ouInfo['indoor-unit'].sort(sortByUnicode('indoor-unit-name'));
      }
    }

    //SLIF
    //空調機の名前で並び替え
    if (info.compositions['sl-system-1']['slif-unit'].length > 0) {
      info.compositions['sl-system-1']['slif-unit'].sort(
        sortByUnicode('unit-name')
      );
    }
    if (info.compositions['sl-system-2']['slif-unit'].length > 0) {
      info.compositions['sl-system-2']['slif-unit'].sort(
        sortByUnicode('unit-name')
      );
    }

    //RT
    //熱源機の名前で並び替え
    if (info.compositions['rt-system-1'].length > 0) {
      info.compositions['rt-system-1'].sort(sortByUnicode('unit-name'));
    }
    if (info.compositions['rt-system-2'].length > 0) {
      info.compositions['rt-system-2'].sort(sortByUnicode('unit-name'));
    }

    //Modbus
    //室外機の名前で並び替え
    if (info.compositions['modbus-system'].length > 0) {
      info.compositions['modbus-system'].sort(sortByUnicode('unit-name'));
      //室内機の名前で並び替え
      for (const ouInfo of info.compositions['modbus-system']) {
        if (ouInfo['indoor-unit'].length === 0) continue;
        ouInfo['indoor-unit'].sort(sortByUnicode('unit-name'));
      }
    }
  }

  return result;
};

/**
 * SL通信設定室外内機の情報の並び替え
 * @param {SLInfoType} slInfo 室内外機の情報
 * @returns ソートされた室内外機の情報
 */
const slInfoSort = (slInfo: apiIF.res.getCompositionsSLUnit) => {
  const result: apiIF.res.getCompositionsSLUnit = JSON.parse(
    JSON.stringify(slInfo)
  );

  //室外機の名前で並び替え
  result['outdoor-unit-informations'].sort(sortByUnicode('outdoor-unit-name'));

  //室内機の名前で並び替え
  for (const ouInfo of result['outdoor-unit-informations']) {
    if (
      ouInfo['indoor-unit-informations'] === undefined ||
      ouInfo['indoor-unit-informations'].length === 0
    ) {
      continue;
    }
    ouInfo['indoor-unit-informations'].sort(sortByUnicode('indoor-unit-name'));
  }

  return result;
};

/**
 * Modbus通信設定室外内機の情報の並び替え
 * @param {MODBUSInfoType} modbusInfo 室内外機の情報
 * @returns ソートされた室内外機の情報
 */
const modbusInfoSort = (modbusInfo: apiIF.res.getCompositionsMoubusUnit) => {
  const result: apiIF.res.getCompositionsMoubusUnit = JSON.parse(
    JSON.stringify(modbusInfo)
  );

  //室外機の名前で並び替え
  result['outdoor-unit-informations'].sort(sortByUnicode('outdoor-unit-name'));

  //室内機の名前で並び替え
  for (const ouInfo of result['outdoor-unit-informations']) {
    if (
      ouInfo['indoor-unit-informations'] === undefined ||
      ouInfo['indoor-unit-informations'].length === 0
    ) {
      continue;
    }
    ouInfo['indoor-unit-informations'].sort(sortByUnicode('indoor-unit-name'));
  }

  return result;
};

export {sortByUnicode, slInfoSort, modbusInfoSort, gwInfoSort};
